import { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import useAbortController from 'hooks/useAbortController';
import { getSecondaryFormData } from 'services/formService';
import { AppContext } from 'contexts/AppContext';
import QUERY_KEYS from 'constants/queryKeys';

const useSecondaryMembersFormDataQuery = ({
  options,
  secondaryMembersApplicantIds,
} = {}) => {
  const abortControllerOptions = useAbortController();
  const { organizationId, propertyId } = useContext(AppContext);

  const queryKey = QUERY_KEYS.secondaryFormData({
    organizationId,
    propertyId,
    secondaryMembersApplicantIds,
  });

  const queryOptions = useMemo(() => {
    return {
      ...options,
      placeholderData: [],
      enabled: Boolean(
        organizationId && propertyId && secondaryMembersApplicantIds?.length,
      ),
    };
  }, [
    options,
    organizationId,
    propertyId,
    secondaryMembersApplicantIds?.length,
  ]);

  return useQuery(
    queryKey,
    () => {
      const promises = secondaryMembersApplicantIds.map(async (applicantId) => {
        const response = await getSecondaryFormData({
          organizationId,
          propertyId,
          applicantId,
          options: abortControllerOptions,
        });

        return { applicantId, ...response };
      });

      return Promise.all(promises);
    },
    queryOptions,
  );
};

export default useSecondaryMembersFormDataQuery;
